import React, { useState, useEffect } from "react";
import "./Contact.css";
import axios from "axios";

const API_BASE_URL = "/api";

// ✅ FIX: Enhanced axios instance with CORS handling
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
  // Add withCredentials if needed for cookies/auth
  // withCredentials: true,
});

// ✅ FIX: Add request interceptor for debugging
api.interceptors.request.use(
  (config) => {
    console.log(
      `🚀 Making ${config.method?.toUpperCase()} request to:`,
      config.url
    );
    console.log("Full config:", config);
    return config;
  },
  (error) => {
    console.error("❌ Request error:", error);
    return Promise.reject(error);
  }
);

// ✅ FIX: Add response interceptor
api.interceptors.response.use(
  (response) => {
    console.log(`✅ Response from ${response.config.url}:`, response.status);
    return response;
  },
  (error) => {
    console.error("❌ Response error:", {
      message: error.message,
      code: error.code,
      status: error.response?.status,
      url: error.config?.url,
    });
    return Promise.reject(error);
  }
);

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    company: "",
    managementLevel: "",
    country: "",
    city: "",
    message: "",
    propertyInterest: "",
    timeline: "",
    contactMethod: "email",
    subscribeNewsletter: true,
    receiveCallback: false,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    console.log("🔍 Starting form submission...");

    try {
      // Test backend connection first - ✅ CHANGED: Use relative URL
      console.log("🔍 Testing backend connection...");
      const testResponse = await api.get("/test");
      console.log("✅ Backend connection test:", testResponse.data);

      // Now submit the form - ✅ CHANGED: Use relative URL
      console.log("🔍 Sending form data to:", "/send-email");
      console.log("📦 Form data:", formData);

      const response = await api.post(
        "/send-email", // ✅ CHANGED: Use relative URL instead of localhost
        formData,
        {
          timeout: 15000,
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("✅ Form submission success:", response.data);

      setSubmitStatus({
        type: "success",
        message: response.data.message,
      });

      // Reset form
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        company: "",
        managementLevel: "",
        country: "",
        city: "",
        message: "",
        propertyInterest: "",
        timeline: "",
        contactMethod: "email",
        subscribeNewsletter: true,
        receiveCallback: false,
      });
    } catch (error) {
      console.error("❌ Form submission failed:", error);

      // Detailed error logging
      if (error.response) {
        console.log("🔍 Error Response:", {
          status: error.response.status,
          data: error.response.data,
          headers: error.response.headers,
        });
      } else if (error.request) {
        console.log("🔍 No response received:", error.request);
      } else {
        console.log("🔍 Error message:", error.message);
      }

      let errorMessage = "Failed to submit your inquiry. ";

      if (error.code === "ECONNREFUSED") {
        errorMessage += "Backend server is not running.";
      } else if (error.response?.status === 404) {
        errorMessage += "Server route not found. Please check backend setup.";
      } else if (error.response?.data?.error) {
        errorMessage += error.response.data.error;
      } else if (error.message) {
        errorMessage += error.message;
      }

      setSubmitStatus({
        type: "error",
        message: errorMessage,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const countries = [
    "India",
    "USA",
    "UK",
    "Canada",
    "Australia",
    "UAE",
    "Singapore",
    "Germany",
    "France",
    "Japan",
    "China",
    "Other",
  ];

  const timelines = [
    "Immediately",
    "Within 1 month",
    "1-3 months",
    "3-6 months",
    "6+ months",
    "Just exploring",
  ];

  const propertyInterests = [
    "Residential Apartment",
    "Independent House/Villa",
    "Commercial Space",
    "Plot/Land",
    "Investment Opportunity",
    "Rental Property",
    "Luxury Residence",
    "Other",
  ];

  return (
    <section className="contact">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Get In Touch With Us</h2>
          <p className="section-subtitle">
            Ready to find your dream property? Fill out the form below and our
            expert team will contact you within 24 hours.
          </p>
        </div>

        <div className="contact-content">
          {/* Contact Information Sidebar */}
          <div className="contact-info-sidebar">
            <div className="info-card">
              <h3>Contact Information</h3>

              <div className="contact-method">
                <div className="contact-icon">📞</div>
                <div className="contact-details">
                  <h4>Phone Numbers</h4>
                  <p>+91 98765 43210</p>
                  <p>+91 98765 43211</p>
                </div>
              </div>

              <div className="contact-method">
                <div className="contact-icon">📧</div>
                <div className="contact-details">
                  <h4>Email Address</h4>
                  <p>info@atlasspaces.in</p>
                  <p>sales@atlasspaces.in</p>
                </div>
              </div>

              <div className="contact-method">
                <div className="contact-icon">🏢</div>
                <div className="contact-details">
                  <h4>Office Address</h4>
                  <p>123 Business District,</p>
                  <p>Pune, Maharashtra 411001</p>
                </div>
              </div>

              <div className="contact-method">
                <div className="contact-icon">🕒</div>
                <div className="contact-details">
                  <h4>Business Hours</h4>
                  <p>Monday - Friday: 9:00 AM - 7:00 PM</p>
                  <p>Saturday: 10:00 AM - 5:00 PM</p>
                </div>
              </div>

              <div className="quick-stats">
                <div className="stat-item">
                  <span className="stat-number">500+</span>
                  <span className="stat-label">Happy Clients</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">50+</span>
                  <span className="stat-label">Projects</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">15+</span>
                  <span className="stat-label">Years Experience</span>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <form
            className="contact-form comprehensive-form"
            onSubmit={handleSubmit}
          >
            {/* Personal Information Section */}
            <div className="form-section">
              <h3 className="section-label">Personal Information</h3>
              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    name="firstName"
                    placeholder="First Name *"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    name="lastName"
                    placeholder="Last Name *"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                    className="form-input"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address *"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number *"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="form-input"
                  />
                </div>
              </div>
            </div>

            {/* Professional Information Section */}
            <div className="form-section">
              <h3 className="section-label">Professional Information</h3>
              <div className="form-row">
                <div className="form-group">
                  <input
                    type="text"
                    name="company"
                    placeholder="Company / Organization *"
                    value={formData.company}
                    onChange={handleChange}
                    required
                    className="form-input"
                  />
                </div>
                <div className="form-group">
                  <select
                    name="managementLevel"
                    value={formData.managementLevel}
                    onChange={handleChange}
                    required
                    className="form-select"
                  >
                    <option value="">Management Level *</option>
                    <option value="C-Level Executive">C-Level Executive</option>
                    <option value="Leagal Advisor">Leagal Advisor</option>
                    <option value="Facility Manager">Facility Manager</option>
                    <option value="Consultant">Consultant</option>
                    <option value="Business Owner">Business Owner</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Location Information */}
            <div className="form-section">
              <h3 className="section-label">Location Details</h3>
              <div className="form-row">
                <div className="form-group">
                  <select
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    required
                    className="form-select"
                  >
                    <option value="">Select Country *</option>
                    {countries.map((country) => (
                      <option key={country} value={country}>
                        {country}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    name="city"
                    placeholder="City *"
                    value={formData.city}
                    onChange={handleChange}
                    required
                    className="form-input"
                  />
                </div>
              </div>
            </div>

            {/* Property Requirements */}
            <div className="form-section">
              <h3 className="section-label">Property Requirements</h3>
              <div className="form-row">
                <div className="form-group">
                  <select
                    name="propertyInterest"
                    value={formData.propertyInterest}
                    onChange={handleChange}
                    className="form-select"
                  >
                    <option value="">Property Type Interest</option>
                    {propertyInterests.map((interest) => (
                      <option key={interest} value={interest}>
                        {interest}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <select
                    name="timeline"
                    value={formData.timeline}
                    onChange={handleChange}
                    className="form-select"
                  >
                    <option value="">Purchase Timeline</option>
                    {timelines.map((timeline) => (
                      <option key={timeline} value={timeline}>
                        {timeline}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <select
                    name="contactMethod"
                    value={formData.contactMethod}
                    onChange={handleChange}
                    className="form-select"
                  >
                    <option value="email">Preferred Contact: Email</option>
                    <option value="phone">Preferred Contact: Phone</option>
                    <option value="whatsapp">
                      Preferred Contact: WhatsApp
                    </option>
                  </select>
                </div>
              </div>
            </div>

            {/* Additional Information */}
            <div className="form-section">
              <h3 className="section-label">Additional Information</h3>
              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Tell us about your specific requirements, preferred locations, amenities, or any other details that will help us serve you better..."
                  rows="6"
                  value={formData.message}
                  onChange={handleChange}
                  className="form-textarea"
                ></textarea>
              </div>

              <div className="checkbox-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="subscribeNewsletter"
                    checked={formData.subscribeNewsletter}
                    onChange={handleChange}
                    className="checkbox-input"
                  />
                  <span className="checkmark"></span>
                  Subscribe to our newsletter for property updates and market
                  insights
                </label>

                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="receiveCallback"
                    checked={formData.receiveCallback}
                    onChange={handleChange}
                    className="checkbox-input"
                  />
                  <span className="checkmark"></span>
                  Request a callback from our property expert
                </label>
              </div>
            </div>

            {/* Submit Section */}
            <div className="form-submit-section">
              {submitStatus && (
                <div className={`status-message ${submitStatus.type}`}>
                  {submitStatus.message}
                </div>
              )}

              <button
                type="submit"
                className={`submit-btn ${isSubmitting ? "submitting" : ""}`}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <div className="spinner"></div>
                    Processing Your Inquiry...
                  </>
                ) : (
                  "Submit Inquiry & Get Expert Assistance"
                )}
              </button>

              <p className="form-note">
                By submitting this form, you agree to our{" "}
                <a href="/privacy">Privacy Policy</a> and consent to be
                contacted by our real estate experts.
              </p>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
